<template lang="pug">
  div
    el-card(class="box-card")
      div(
        slot="header"
        class="clearfix"
        )
        img(
          class="library-icon"
          :src="require(`@/assets/icons/${libraryType}_library.svg`)"
        )
        span(class="library-title") {{ headerLabel }} 
        el-button(
          style="margin-left: 1.5em"
          class="normal-button"
          @click="$emit('showLibraryModal')"
          :loading="processing"
          icon="el-icon-notebook-2")
            small Switch
      el-row(style="margin: 0% 2% 0% 2%; display: flex; flex-direction: row; justify-content: left; flex-wrap: wrap; align-items: baseline;")
        el-select#tag-select(
            v-model="value"
            multiple
            filterable
            reserve-keyword
            clearable
            placeholder="Please enter a tag to search"
            no-data-text="No tags found"
            no-match-text="No tag matches found"
            :loading="loading")
            el-option#tag-options(
              v-for="value in sortedTags"
                :key="value"
                :label="value"
                :value="value"
            )
        el-button(
            style="margin-left: 1.5em"
            class="primary-button"
            @click="search(true)"
            icon="el-icon-search") 
              small Search

      // Pagination
      el-row
        div(style="float:right; margin: 2%")
          el-pagination(
            v-if="pagination.totalQuestions > maxPageLimit"
            :page-size="maxPageLimit"
            :total="pagination.totalQuestions"
            :current-page="pagination.currentPage"
            @next-click="pageChange(1)"
            @prev-click="pageChange(-1)"
            @current-change="handleCurrentChange"
            layout="prev, pager, next"
            style="float:right;")
  
      el-row
        div(v-for="item in questionList")
          question-preview(
            :id="item.id"
            :questionData="item"
            :showPreview="true"
            :showTags="true"
            :selectOnly="true"
          )

      // Pagination
      el-row
        div(style="float:right; margin: 2%")
          el-pagination(
            v-if="pagination.totalQuestions > maxPageLimit"
            :page-size="maxPageLimit"
            :total="pagination.totalQuestions"
            :current-page="pagination.currentPage"
            @next-click="pageChange(1)"
            @prev-click="pageChange(-1)"
            @current-change="handleCurrentChange"
            layout="prev, pager, next"
            style="float:right;")
</template>

<script>
import QuestionPreview from "@/components/demo/preview/QuestionPreview";

import { MAX_PAGE_LIMIT } from "@/defines/constants";

export default {
  name: "QuestionLibrary",
  components: {
    QuestionPreview
  },

  props: {
    libraryType: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      data: null,
      value: [],
      loading: false,
      processing: false,
      tagsList: {},
      filterTags: [],
      allQuestions: [],
      questionList: [],
      selectedQuestionsList: [],
      pagination: {
        totalQuestions: 0,
        currentPage: 1
      },
      maxPageLimit: MAX_PAGE_LIMIT,
      pointsMsg:
        '<br><br><div class="points-import-note"><span style="color:red;">*</span><span style="font-size: 14px"> Assign default point(s) per question:</span></div>'
    };
  },

  computed: {
    headerLabel() {
      return `Sample Questions from the ${this.libraryType
        .charAt(0)
        .toUpperCase() + this.libraryType.slice(1)} Library`;
    },

    sortedTags() {
      var sortedTagsList = [];
      for (const [, value] of Object.entries(this.tagsList))
        sortedTagsList.push(value);
      sortedTagsList.sort();
      return sortedTagsList;
    }
  },

  watch: {
    libraryType() {
      this.getQuestions();
    },

    filterTags() {
      this.questionList = [];
      if (this.filterTags.length >= 1) {
        for (const question of this.allQuestions) {
          let match = false;
          for (const filterTag of this.filterTags) {
            if (!question.activeTags.includes(filterTag)) {
              break;
            }
            match = true;
          }
          if (match) {
            this.questionList.push(question);
          }
        }
      } else {
        this.questionList = this.allQuestions;
      }
    }
  },

  mounted() {
    this.getQuestions();
  },

  methods: {
    getQuestions() {
      // Retrieve Tags data from json file
      var tagsData = require(`@/defines/demo/question-tags.json`)[
        this.libraryType
      ];

      // Retrieve questions list from json file
      this.allQuestions = require(`@/defines/demo/${this.libraryType}-library.json`)[
        "questions"
      ];

      // Only include tags that are active in sample questions only
      var currentTags = [];
      for (let i = 0; i < this.allQuestions.length; i++) {
        this.allQuestions[i].activeTags = [];
        for (const tagId of this.allQuestions[i].tags) {
          this.allQuestions[i].activeTags.push(tagsData[tagId]);
          if (!currentTags.includes(tagId)) {
            currentTags.push(tagId);
          }
        }
      }

      this.tagsList = [];
      for (const [id, tag] of Object.entries(tagsData)) {
        if (currentTags.includes(JSON.parse(id))) {
          this.tagsList[id] = tag;
        }
      }

      this.questionList = this.allQuestions;
      this.processing = false;
    },

    search() {
      this.filterTags = [];
      this.value.forEach(item => {
        if (this.tagsList.includes(item)) {
          this.filterTags.push(item);
        }
      });
    },

    pageChange(step) {
      let totalPages = this.pagination.totalQuestions / this.maxPageLimit;
      if (step > 0) {
        if (this.pagination.currentPage < totalPages) {
          this.pagination.currentPage += 1;
        }
      } else {
        if (this.pagination.currentPage > 1) {
          this.pagination.currentPage -= 1;
        }
      }
      this.search();
    },

    handleCurrentChange(page) {
      this.pagination.currentPage = page;
      this.search();
    }
  }
};
</script>

<style>
#tag-select {
  width: 300px;
}

#tag-options {
  font-size: 16px;
}

#tag-text {
  font-size: 14px;
  color: #00a8ff;
  display: block;
  margin-top: 8px;
}

.library-icon {
  width: 2.5em;
  height: 2.5em;
  padding-right: 0.5em;
  vertical-align: top;
}
</style>
